var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 41,
    viewBox: "0 0 45 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.84973 6.04537L8.71573 1.61332C9.09736 1.26573 9.68084 1.26573 10.0625 1.61332L18.3366 9.14959C18.7721 9.54625 18.7721 10.2315 18.3366 10.6282L14.8509 13.8031C14.5093 14.1142 14.4253 14.6187 14.6476 15.0236L15.4718 16.525C17.8587 20.873 21.5872 24.3329 26.1012 26.3886L28.3073 27.3933C28.6714 27.5591 29.0993 27.492 29.3951 27.2226L33.1138 23.8355C33.4954 23.4879 34.0789 23.4879 34.4605 23.8355L42.7347 31.3718C43.1702 31.7685 43.1702 32.4538 42.7347 32.8504L37.2945 37.8055C35.2387 39.6779 32.1659 39.8925 29.8698 38.324L16.9705 29.5123C15.1783 28.288 13.5685 26.8163 12.1888 25.1408L3.25816 14.2952C1.2257 11.8269 1.48588 8.19841 3.84973 6.04537Z",
    stroke: "#33363F",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.3eef92c3c24bcff4edb234d8c83a47e9.svg";
export { ForwardRef as ReactComponent };